// extracted by mini-css-extract-plugin
export default {"qLoadingWrapper":"QLoading_qLoadingWrapper__4kwJA","qLoading":"QLoading_qLoading__PWMRR"};